import React from 'react';

import { format, parseISO } from 'date-fns';
import { WorkflowCompleteIllustration } from 'src/components/icons/WorkflowCompleteIllustration';
import { getWorkflowRuntimeString } from 'src/components/workflow/workflow-helpers';
import type { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  heading: {
    color: '#324A52',
    fontSize: 24,
    fontWeight: 700,
    margin: 0,
    textAlign: 'center',
  },
  illustration: {
    display: 'block',
    flexShrink: 0,
  },
  root: {
    alignItems: 'center',
    background: 'rgba(219, 230, 228, 0.02)',
    border: '1px solid #e2e8f0',
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    justifyContent: 'center',
    padding: theme.spacing(2, 1),
    width: '100%',
  },
  subtitle: {
    color: '#324A52',
    fontSize: 16,
    margin: 0,
    textAlign: 'center',
  },
  textGroup: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

interface WorkflowPhasesCompleteCardProps {
  workflow: Pick<
    Apollo.Workflow,
    '__typename' | 'completedAt' | 'createdAt' | 'startedAt' | 'variant'
  >;
}

export function WorkflowPhasesCompleteCard({ workflow }: WorkflowPhasesCompleteCardProps) {
  const { classes } = useStyles();
  const completionSubtitle = buildCompletionSubtitle(workflow);

  return (
    <div className={classes.root}>
      <WorkflowCompleteIllustration />
      <div className={classes.textGroup}>
        <p className={classes.heading}>All phases complete</p>
        {completionSubtitle && <p className={classes.subtitle}>{completionSubtitle}</p>}
      </div>
    </div>
  );
}

function buildCompletionSubtitle(
  workflow: Pick<
    Apollo.Workflow,
    '__typename' | 'completedAt' | 'createdAt' | 'startedAt' | 'variant'
  >
): string | null {
  if (!workflow.completedAt) return null;

  const runtime = getWorkflowRuntimeString(workflow);
  const formattedDate = format(parseISO(workflow.completedAt), 'MMM d, yyyy');

  return `On ${formattedDate} • ${runtime}`;
}
